const KEY = 'sn_customers_waitlist_v1';

function seed() {
  const items = [
    {
      id: 1,
      name: 'Bilal Ahmed',
      email: 'bilal@example.com',
      phone: '0301-1112233',
      address: 'Gulshan-e-Iqbal, Karachi',
      productId: 2,
      productName: 'Gadget B',
      requiredQuantity: 2,
      createdAt: new Date().toISOString(),
    },
  ];
  localStorage.setItem(KEY, JSON.stringify(items));
  return items;
}

export function getAll() {
  const raw = localStorage.getItem(KEY);
  if (!raw) return seed();
  try {
    return JSON.parse(raw);
  } catch (e) {
    return seed();
  }
}

export function getById(id) {
  const items = getAll();
  return items.find((c) => c.id === Number(id));
}

function persist(items) {
  localStorage.setItem(KEY, JSON.stringify(items));
}

export function create(entry) {
  const items = getAll();
  const nextId = items.length ? Math.max(...items.map((c) => c.id)) + 1 : 1;
  const newItem = { id: nextId, createdAt: new Date().toISOString(), ...entry };
  items.push(newItem);
  persist(items);
  return newItem;
}

export function update(id, data) {
  const items = getAll();
  const idx = items.findIndex((c) => c.id === Number(id));
  if (idx === -1) return null;
  items[idx] = { ...items[idx], ...data };
  persist(items);
  return items[idx];
}

export function remove(id) {
  let items = getAll();
  items = items.filter((c) => c.id !== Number(id));
  persist(items);
}

export default { getAll, getById, create, update, remove };
